<form [formGroup]="form" class="container">
  <app-titulo>Suprimentos</app-titulo>
  <div class="inputs">
    <app-input
      type="money"
      label="Valor"
      name="VL_MOVM_CAIX"
      formControlName="VL_MOVM_CAIX"
      placeholder="Digite aqui"></app-input>
    <app-input
      type="text"
      label="Motivo"
      name="TX_MOTV_MOVM_CAIX"
      formControlName="TX_MOTV_MOVM_CAIX"
      placeholder="Digite aqui"></app-input>
    <app-input
      type="disabled"
      label="Usuário"
      name="NM_FUNC_OPER"
      formControlName="NM_FUNC_OPER"></app-input>
    <app-input
      type="disabled"
      label="Horário"
      name="DT_MOVM_CAIX"
      formControlName="DT_MOVM_CAIX"></app-input>
  </div>
  <div class="buttons">
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()" />
    <app-botao
      text="Confirmar"
      [bgColor]="!form.valid ? '' : '#059669'"
      (click)="postSuprimentos()"
      [disabled]="!form.valid" />
  </div>
</form>

<app-loader [isLoading]="isLoading" />
